<template>
    <transition
            enter-active-class="animated slideInLeft"
            leave-active-class="animated slideOutRight">
        <span v-if="value === true">
            <slot name="loading"></slot>
            <fa icon="circle-notch" spin></fa>
        </span>
        <span v-else>
            <slot></slot>
            <fa v-if="icon !== null" :icon="icon"></fa>
        </span>
    </transition>
</template>

<script>
  export default {
    name: "loading-icon",
    props: {
      value: {
        default: false
      },
      icon: {
        default: null
      }
    }
  }
</script>

<style scoped>

</style>